
import React from 'react'
import Grid from '@material-ui/core/Grid'
import  Typography  from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import MainGridItem from './MainGridItem';
import GridItem from './GridItem';

const useStyles = makeStyles(theme =>({
    mainGridItem: {
        backgroundColor: 'pink',
    },
    secondRowFirstItem: {
        backgroundColor: 'orange',
    },
    secondRowSecondItem: {
        backgroundColor: 'yellow',
    },
    thirdRowFirstItem: {
        backgroundColor: 'green',
        color: 'white',
    }
}));

function GridLayout() {

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item lg={12} sm={12} xs={12}>
                <MainGridItem/>

            </Grid >
            <Grid item lg={6} md={12} sm={12} xs={12}>
                <GridItem title="Clones" 
                subheader="Aplicación de tecnología" 
                image="https://cdn.pixabay.com/photo/2017/10/29/15/34/stormtrooper-2899993_960_720.jpg" 
                paragraph="Se demuestran habilidades FrontEnd y BackEnd, en cada uno de los clones de los diversos sitios web donde se usa ReactJS, HTML, CSS, JavaScript, Material-UI, entre muchas otras tecnologías."/>
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12}>
                <GridItem 
                title="Aplicativos" 
                subheader="Compartir es vivir" 
                image="https://cdn.pixabay.com/photo/2018/07/12/21/32/subscribe-3534409_960_720.jpg" 
                paragraph="Se coloca al alcance de todos, algunos aplicativos web de propia autoría, esperando que sean de utilidad"
                />
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
                <GridItem
                title="Libros" 
                subheader="Libros sobre tecnología y filosofía" 
                image="https://cdn.pixabay.com/photo/2018/03/19/18/20/tea-time-3240766_960_720.jpg" 
                paragraph="Algunos libros ya publicados en Amazon, sobre tecnología y filosofía"
                />
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
                <GridItem
                title="Blog" 
                subheader="Reflexiones sobre tecnología y filosofía" 
                image="https://cdn.pixabay.com/photo/2014/05/02/21/50/home-office-336377_960_720.jpg" 
                paragraph="Nada mejor que buenas reflexiones, usando la palabra como vehículo del pensamiento"
                />
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12}>
                <GridItem
                title="Video Blog" 
                subheader="Like and suscribe a Catalyst Tech" 
                image="https://cdn.pixabay.com/photo/2015/03/26/09/43/camera-690163_960_720.jpg" 
                paragraph="Incursionando en el video Blog, con temas sobre tecnología, filosofía y desarrollo Frontend"
                />
            </Grid>
        </Grid>
    )
}

export default GridLayout
